import { ClassificationsListModel } from '../classifications-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 部門情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetClassificationsListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetClassificationsListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: ClassificationsListModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetClassificationsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param {ClassificationsListModel} model モデルクラス
   * @memberof GetClassificationsListService
   */
  execute(model: ClassificationsListModel) {
    this.model = model;
    this.send('KYMW02getClassList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetClassificationsListService
   */
  success(data: any) {
    this.model.updateList(data);
  }

}
